import React, { useState } from "react";
import { Link } from "react-router-dom";
import ProgressBar from "react-bootstrap/ProgressBar";
import Calculator from "../../Common/Calculator";
import BuyModal from "../../Layout/Modal/BuyModal";

const Hero = () => {
  const options = [
    {
      label: "USDT",
      value: "USDT",
      image: "/images/usdt-removebg-preview.png",
    },
    { label: "BNB", value: "BNB", image: "/images/bnb-bnb-logo.png" },
    {
      label: "WETH",
      value: "WETH",
      image: "/images/ethereum-logo-EC6CDBA45B-seeklogo.com.png",
    },
  ];
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(options[0]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };

  const files = [
    { name: "ZFORGE-WHITEPAPER", url: "/images/ZFORGE-WHITEPAPER.pdf" },
  ];
  const downloadFiles = () => {
    files.forEach((file) => {
      const link = document.createElement("a");
      link.href = file.url;
      link.download = file.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  return (
    <>
      <section className="Hero">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-6">
              <div className="hero-content">
                <div class="text-animate">
                  <span>F</span>
                  <span>O</span>
                  <span>R</span>
                  <span>&nbsp;</span>
                  <span>E</span>
                  <span>A</span>
                  <span>R</span>
                  <span>L</span>
                  <span>Y</span>
                  <span>-</span>
                  <span>B</span>
                  <span>I</span>
                  <span>R</span>
                  <span>D</span>
                  <span>S</span>
                  <span>&nbsp;</span>
                  <span>O</span>
                  <span>N</span>
                  <span>L</span>
                  <span>Y!</span>
                </div>
                <h1
                  className="blue"
                  style={{ fontSize: "40px", fontStyle: "italic" }}
                >
                  <span style={{ color: "#000" }}>Buy and Stake</span> 1,000%
                  APY
                </h1>
                <h1>
                  <span className="blue">AI-Powered</span>&nbsp; P2E Gaming and
                  Metaverse <br />
                </h1>
                <p>
                  ZForge is evolving into a full-fledged metaverse,
                  offering virtual exploration, cross-game NFT integration,
                  and community-driven updates. Join us as we build a
                  sustainable future for gaming.
                </p>
                <div className="btns">
                  <Link className="start" onClick={downloadFiles} to="">
                    Whitepaper
                  </Link>
                  <BuyModal />
                  {/* <Link className="explore" to="">
                    BUY WITH CRYPTO
                  </Link> */}
                </div>
              </div>
            </div>
            <div
              className="offset-lg-1 col-lg-5 col-md-12 col-sm-12"
              id="calculator"
            >
              <Calculator />
              {/* <div className="calculator">
                <div className="content">
                  <h2>$ZEUSS Pre-Sale</h2>
                  <div className="progress">
                    <span>10M/200M $ZEUSS</span>
                    <ProgressBar now={10} />
                  </div>
                  <div className="launch-price">
                    <h4>
                      Current PreSale Price = <span>$0.0084280</span>
                    </h4>
                  </div>
                  <form className="calculateform">
                    <div className="form-group">
                      <div className="form-heading">
                        <label>I want to spend</label>
                      </div>

                      <div className="form">
                        <div>
                          <input
                            maxLength={10}
                            type="text"
                            className="form-control"
                            placeholder="Limit 10 - 5000"
                          />
                        </div>
                        <div className="select">
                          <div className="dropdown">
                            <div
                              className="dropdown-header"
                              onClick={toggleDropdown}
                            >
                              {selectedOption && (
                                <div className="dropdown-selected">
                                  <img
                                    src={selectedOption.image}
                                    alt={selectedOption.label}
                                  />
                                  <span>{selectedOption.label}</span>
                                  <i
                                    className={`dropdown-icon ${
                                      isOpen ? "open" : ""
                                    }`}
                                  >
                                    <img
                                      src="/images/calculatedrop.png"
                                      alt=""
                                    />
                                  </i>
                                </div>
                              )}
                            </div>
                            {isOpen && (
                              <div className="dropdown-list">
                                {options.slice(0 || 1).map((option) => (
                                  <div
                                    key={option.label}
                                    className="dropdown-item"
                                    onClick={() => handleOptionClick(option)}
                                  >
                                    <img
                                      src={option.image}
                                      alt={option.label}
                                    />
                                    <span>{option.label}</span>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="form-heading">
                        <label>I will receive</label>
                        <label>1USDT = 118.65ZEUSS </label>
                      </div>
                      <div className="form">
                        <div>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="0"
                          />
                        </div>
                        <div className="select">
                          <img src="/images/zeusscircle.png" alt="" />
                        </div>
                      </div>
                    </div>
                    <div className="calculate-btn">
                      <div className="row" style={{ minHeight: "auto" }}>
                        <div className="col-lg-6 col-sm-12">
                          <button type="button" className="btn form-control">
                            Buy with
                            <img src="./images/card.png" alt="" />
                          </button>
                        </div>
                        <div className="col-lg-6 col-sm-12">
                          <button type="button" className="btn form-control">
                            Buy with
                            <img src="./images/paypal.png" alt="" />
                          </button>
                        </div>
                      </div>
                      <button type="button" className="btn form-control">
                        Buy & Stake $ZEUSS
                      </button>
                      <button type="button" className="btn form-control">
                        Buy $ZEUSS
                      </button>
                    </div>
                  </form>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Hero;
